const logError = (...data : any[]) => console.error(data);

export {
  logError
}
